/**
 * Сколько элементов бэкенд отдаёт за один запрос.
 *
 * Потолок жёсткий и **молчаливый**: `limit: 25` не ошибка, просто в ответе придёт
 * двадцать. Отсюда два следствия для движка пагинации:
 *
 * - размер страницы больше потолка недопустим — вторая страница ушла бы с
 *   `offset = perPage`, и элементы между двадцатым и `perPage`-м не показались бы
 *   никогда;
 * - приём «запросить `perPage + 1`, лишний элемент = есть следующая страница»
 *   перестаёт работать ровно на `perPage = MAX_REQUEST_LIMIT`: двадцать первый
 *   элемент просто не придёт. В этом случае `usePagedList` спрашивает про
 *   следующую страницу отдельным лёгким запросом (`limit: 1`).
 */
export const MAX_REQUEST_LIMIT = 20;
